import { apiSalesWeb } from '@shared/config';

export interface ICreateCrossSellerOutput {
  id: string;
}

export function createCrossSeller(payload: { companyId: string }) {
  return apiSalesWeb.post<ICreateCrossSellerOutput>(
    '/checkout/authenticated',
    payload,
  );
}
